import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdClass, MdDownload, MdEmail, MdEventNote, MdInbox, MdInfo, MdLockReset, MdMailOutline, MdMarkunreadMailbox, MdOutlineSettingsSuggest, MdPeople, MdSchool, MdSettings, MdSettingsAccessibility, MdStorage, MdTranslate } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { FaUserGraduate } from 'react-icons/fa';
import axios from "axios";
import { web_url } from "../../constant";

const url = "http://localhost:8080/api/";

const ROUND_BOUNDARIES = [
    { label: "Round 1 (up to 06 Sep 2026)", value: "1", start: null, end: new Date("2026-09-06T23:59:59") },
    { label: "Round 2 (07 Sep 2026 - Present)", value: "2", start: new Date("2026-09-07T00:00:00"), end: null },
];
function ResearcherDashboardMobilePage() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);

    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };


    const [loadingValues, setLoadingValues] = useState(false);

    const [pendingEmails, setPEmails] = useState(0);
    const [translatedEmails, setTEmails] = useState(0); // week
    const [rejectedMails, setRMails] = useState(0);
    const [totalMessages, setTotalMessages] = useState("0"); // today

    const [treatmentStudent, setTreatmentStudent] = useState(0)
    const [controlStudent, setControlStudent] = useState(0)
    const [studentsNumber, setStudentsNumber] = useState(0)
    const [teacherNumber, setTeacherNumber] = useState(0)
    const [translatorNumber, setTranslatorNumber] = useState(0)

    const [loadingTeacher, setLoadingTeacher] = useState(false);
    const [loadingControlStudent, setLoadingControlStudent] = useState(false);
    const [loadingTreatmentStudent, setLoadingTreatmentStudent] = useState(false);
    const [loadingStudent, setLoadingStudent] = useState(false);
    const [loadingTranslator, setLoadingTranslator] = useState(false);
    const [loadingTodayMails, setLoadingTodayMails] = useState(false);

    const [selectedRound, setSelectedRound] = useState("1");
    const [roundDownloadLoading, setRoundDownloadLoading] = useState(false);

    const stripHtml = (html) =>
        (typeof html === "string" ? html : "").replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();

    const formatDT = (ts) => {
        if (!ts) return "—";
        return new Date(ts).toLocaleString("en-GB", { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" });
    };

    const getReceiverM = (msg) => {
        const participants = msg.threadParticipants || msg.participants || [];
        const receiver = participants.find((p) => p !== msg.sender);
        return receiver || "—";
    };

    const getRoundLabel = () => {
        const round = ROUND_BOUNDARIES.find((r) => r.value === selectedRound);
        return round ? round.label.replace(/[^a-z0-9]/gi, "_").toLowerCase() : "round";
    };

    const fetchRoundLetters = async (roundVal, hdrs) => {
        const round = ROUND_BOUNDARIES.find((r) => r.value === roundVal);
        const params = new URLSearchParams();
        if (round?.start) params.append("startDate", round.start.toISOString());
        if (round?.end) params.append("endDate", round.end.toISOString());
        const qs = params.toString();
        const roundUrl = `${web_url}/api/email-threads/round-letters${qs ? `?${qs}` : ""}`;
        const res = await axios.get(roundUrl, hdrs);
        if (!Array.isArray(res.data)) throw new Error("Invalid export response");
        return res.data;
    };

    const downloadRoundExcel = async () => {
        const token = (JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails")))?.token;
        if (!token) return;
        setRoundDownloadLoading(true);
        const hdrs = { headers: { Authorization: `Bearer ${token}` } };
        try {
            const round = ROUND_BOUNDARIES.find((r) => r.value === selectedRound);
            const params = new URLSearchParams();
            if (round?.start) params.append("startDate", round.start.toISOString());
            if (round?.end) params.append("endDate", round.end.toISOString());
            const qs = params.toString();
            const excelUrl = `${web_url}/api/email-threads/round-letters/excel${qs ? `?${qs}` : ""}`;

            const res = await axios.get(excelUrl, { ...hdrs, responseType: "blob" });
            if (!res.data || res.data.size === 0) throw new Error("Empty export response");
            const objectUrl = window.URL.createObjectURL(res.data);
            const link = document.createElement("a");
            link.href = objectUrl;
            link.download = `letters_${getRoundLabel()}_${new Date().toISOString().slice(0, 10)}.xlsx`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000);
        } catch (e) {
            window.alert("Unable to download Excel. Please try again.");
        } finally {
            setRoundDownloadLoading(false);
        }
    };

    const downloadRoundPdf = async () => {
        const token = (JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails")))?.token;
        if (!token) return;
        // Open synchronously while the click still grants popup permission.
        const printWindow = window.open("", "_blank");
        if (!printWindow) {
            window.alert("Please allow popups to download the PDF.");
            return;
        }
        printWindow.document.body.textContent = "Preparing letters…";
        setRoundDownloadLoading(true);
        const hdrs = { headers: { Authorization: `Bearer ${token}` } };
        try {
            const letters = await fetchRoundLetters(selectedRound, hdrs);
            if (!letters || letters.length === 0) {
                printWindow.close();
                window.alert("No letters found for this round.");
                return;
            }
            const roundLabelDisplay = ROUND_BOUNDARIES.find((r) => r.value === selectedRound)?.label || "All Letters";
            let bodyContent = "";
            letters.forEach((msg, i) => {
                const receiver = getReceiverM(msg);
                const originalText = stripHtml(msg.body);
                const englishText = stripHtml(msg.englishBody);
                const translatedText = msg.translatedBody && msg.translatedBody !== "NA" ? stripHtml(msg.translatedBody) : "";
                const status = msg.moderationRecord?.action || (msg.moderationRecord === null ? "Pending" : "—");
                bodyContent += `<div class="letter" style="${i > 0 ? "page-break-before:always;" : ""}"><h2 style="font-size:16px;color:#A07B00;margin-bottom:8px;border-bottom:2px solid #FDC50C;padding-bottom:6px;">Letter ${i + 1}</h2><table style="font-size:12px;margin-bottom:12px;border-collapse:collapse;width:100%;"><tr style="border-bottom:1px solid #eee;"><td style="padding:6px 12px 6px 0;font-weight:bold;color:#555;width:180px;">To:</td><td>${receiver}</td></tr><tr style="border-bottom:1px solid #eee;"><td style="padding:6px 12px 6px 0;font-weight:bold;color:#555;">From:</td><td>${msg.sender || "—"}</td></tr><tr style="border-bottom:1px solid #eee;"><td style="padding:6px 12px 6px 0;font-weight:bold;color:#555;">Date &amp; Time Sent:</td><td>${formatDT(msg.sentAt)}</td></tr><tr><td style="padding:6px 12px 6px 0;font-weight:bold;color:#555;">Status:</td><td style="font-weight:600;color:#A07B00;">${status}</td></tr></table>${originalText ? `<div style="margin-top:14px;"><p style="font-size:12px;font-weight:bold;color:#1A5276;margin-bottom:6px;border-left:3px solid #1A5276;padding-left:8px;">Original Letter</p><div style="font-size:12px;background:#F4F8FC;border:1px solid #D6E4F0;border-radius:4px;padding:12px 16px;line-height:1.8;white-space:pre-wrap;">${originalText}</div></div>` : ""}${englishText ? `<div style="margin-top:14px;"><p style="font-size:12px;font-weight:bold;color:#217346;margin-bottom:6px;border-left:3px solid #217346;padding-left:8px;">English Version</p><div style="font-size:12px;background:#F0FBF4;border:1px solid #B7DFC5;border-radius:4px;padding:12px 16px;line-height:1.8;white-space:pre-wrap;">${englishText}</div></div>` : ""}${translatedText ? `<div style="margin-top:14px;"><p style="font-size:12px;font-weight:bold;color:#856404;margin-bottom:6px;border-left:3px solid #856404;padding-left:8px;">Translated Version</p><div style="font-size:12px;background:#FFFDF0;border:1px solid #FFEBAA;border-radius:4px;padding:12px 16px;line-height:1.8;white-space:pre-wrap;">${translatedText}</div></div>` : ""}</div>`;
            });
            const fullHtml = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Letters — ${roundLabelDisplay}</title><style>@font-face{font-family:'Noto Sans Sinhala';src:url('${window.location.origin}${process.env.PUBLIC_URL || ""}/fonts/NotoSansSinhala-Regular.ttf')}@font-face{font-family:'Noto Sans Tamil';src:url('${window.location.origin}${process.env.PUBLIC_URL || ""}/fonts/NotoSansTamil-Regular.ttf')}body{font-family:Arial,'Noto Sans Sinhala','Noto Sans Tamil',sans-serif;padding:20px;color:#333;}.letter{page-break-inside:avoid;margin-bottom:30px;}</style></head><body><h1 style="font-size:22px;color:#A07B00;border-bottom:2px solid #FDC50C;padding-bottom:10px;">Letters — ${roundLabelDisplay}</h1><p style="font-size:13px;color:#666;">Total: ${letters.length} | Generated: ${new Date().toLocaleString()}</p><hr style="border:1px solid #eee;margin:20px 0;" />${bodyContent}<script>document.fonts.ready.then(function(){window.print();});<\/script></body></html>`;
            printWindow.document.open();
            printWindow.document.write(fullHtml);
            printWindow.document.close();
        } catch (e) {
            printWindow.close();
            window.alert("Unable to download PDF. Please try again.");
        } finally {
            setRoundDownloadLoading(false);
        }
    };

    useEffect(() => {
        localStorage.removeItem('studentEmailForResetPassword');
    }, []);

    //control stu
    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            setLoadingControlStudent(true);
            const details = {
                accountStatus: "ACTIVE",
                penpalGroup: "CONTROL"
            };

            const apiUrl = `${url}auth/students/filter`
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${logDetails.token}`,
                },
            };

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };

            axios.post(`${web_url}/api/auth/students/filter`, details, config)
                .then((response) => {
                    try {
                        const totalStudentsNumber = response.data.length;
                        setControlStudent(totalStudentsNumber);
                    } catch {
                        setControlStudent(0);
                    }

                    setLoadingControlStudent(false);
                })
                .catch((err) => {
                    console.log("error occured", err);
                    setLoadingControlStudent(false);
                });
        }
    }, [])

    //treat stu
    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            setLoadingTreatmentStudent(true);
            const details = {
                accountStatus: "ACTIVE",
                penpalGroup: "TREATMENT"
            };

            const apiUrl = `${url}auth/students/filter`
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${logDetails.token}`,
                },
            };

            // axios.post(apiUrl, researcher, config)
            axios.post(`${web_url}/api/auth/students/filter`, details, config)
                .then((response) => {
                    try {
                        const totalStudentsNumber = response.data.length;
                        setTreatmentStudent(totalStudentsNumber);
                    } catch {
                        setTreatmentStudent(0);
                    }

                    setLoadingTreatmentStudent(false);
                })
                .catch((err) => {
                    console.log("error occured");
                    setLoadingTreatmentStudent(false);
                });
        }
    }, [])

    //total active stu
    const getLogDetails = () => {
        return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
    };
    const logDetails = getLogDetails();

    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            setLoadingStudent(true);
            const details = {
                accountStatus: "ACTIVE",
            };

            const apiUrl = `${url}auth/students/filter`
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${logDetails.token}`,
                },
            };

            // axios.post(apiUrl, researcher, config)
            axios.post(`${web_url}/api/auth/students/filter`, details, config)
                .then((response) => {
                    try {
                        const totalStudentsNumber = response.data.length;
                        setStudentsNumber(totalStudentsNumber);
                    } catch {
                        setStudentsNumber(0);
                    }

                    setLoadingStudent(false);
                })
                .catch((err) => {
                    console.log("error occured");
                    setLoadingStudent(false);
                });
        }
    }, [])

    //teacher
    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            setLoadingTeacher(true);

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };

            const apiUrl = `${web_url}/api/auth/teachers`

            // axios.post(apiUrl, researcher, config)
            axios.get(apiUrl, configToken)
                .then((response) => {
                    try {
                        const totalTeacherNumber = response.data.length;
                        setTeacherNumber(totalTeacherNumber);
                    } catch {
                        setTeacherNumber(0);
                    }

                    setLoadingTeacher(false);
                })
                .catch((err) => {
                    console.log("error occured");
                    setLoadingTeacher(false);
                });
        }
    }, [])

    //translator
    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            setLoadingTranslator(true);

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };

            const apiUrl = `${web_url}/api/auth/translators`

            axios.get(apiUrl, configToken)
                .then((response) => {
                    try {
                        const totalTranslatorNumber = response.data.length;
                        setTranslatorNumber(totalTranslatorNumber);
                    } catch {
                        setTranslatorNumber(0);
                    }

                    setLoadingTranslator(false);
                })
                .catch((err) => {
                    console.log("error occured");
                    setLoadingTranslator(false);
                });
        }
    }, [])

    //total emails today
    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            setLoadingTodayMails(true);

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };

            const apiUrl = `${web_url}/api/email-threads/emails-sent-today`

            axios.get(apiUrl, configToken)
                .then((response) => {
                    try {
                        const totalMails = response.data.message;
                        setTotalMessages(totalMails);
                    } catch {
                        setTotalMessages("0");
                    }

                    setLoadingTodayMails(false);
                })
                .catch((err) => {
                    console.log("error occured");
                    setLoadingTodayMails(false);
                });
        }
    }, [])



    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            setLoadingValues(true);

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };

            axios.get(`${web_url}/api/email-threads/moderator-counts`, configToken)
                .then((response) => {
                    setPEmails(response.data?.pending || 0);
                    setTEmails(response.data?.approved || 0);
                    setRMails(response.data?.rejected || 0);
                    setLoadingValues(false);
                })
                .catch((err) => {
                    setPEmails(0);
                    setTEmails(0);
                    setRMails(0);
                    setLoadingValues(false);
                });
        }

    }, [])


    const [isOverViewSelected, setIsOverViewSelected] = useState(true);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 1270) {
                navigate('/desktop/researcher/dashboard')
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };

        const checkAuth = () => {
            const logDetails = getLogDetails();
            const currentTime = new Date();

            if (!logDetails) {
                alert("Please re-sign up to continue");
                localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            } else if (logDetails.category.toLowerCase() !== "researcher") {
                alert("Please re-sign up to continue");
                // localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            }

            if (sessionStorage.getItem('exp')) {
                if (new Date(sessionStorage.getItem('exp')) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                } else if (sessionStorage.getItem('exp') !== logDetails.exp) {
                    alert("Please re-sign up to continue");
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            } else {
                sessionStorage.setItem('exp', logDetails.exp);
                if (new Date(logDetails.exp) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            }
        };

        checkAuth(); // Run on mount

        const handleStorageChange = (event) => {
            if (event.key === "logDetails") {
                checkAuth(); // Re-check authentication if storage changes
            }
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);


    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} bg-bgImg md:bg-bglarge bg-repeat bg-cover min-h-screen w-screen xl:pt-[50px]`}>
            <div className="xl:hidden absolute top-0 left-0 py-[25px] pl-[20px] md:pl-[30px] lg:pl-[40px]">
                <div className="flex justify-center items-center" >
                    <img className="h-[50px] md:h-[70px] lg:h-[90px]" src="/images/logo.svg" alt="logo" />
                    <p className="ml-[10px] mr-[100px]  font-semibold text-[15px] md:text-[20px] lg:text-[25px]">{t('t1')}</p>
                </div>
            </div>
            <Menu as="div" className="xl:hidden absolute top-0 right-0 text-left items-right py-[30px] md:py-[35px] pr-[20px] md:pr-[30px] lg:pr-[40px]">
                <div>
                    <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 lg:py-3 text-sm md:text-[17px] md:text-[21px] font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                        {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 md:size-6 text-gray-400" />
                    </MenuButton>
                </div>

                <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-[200px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    <div className="py-1">
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("English");
                                    changeLanguage('en')
                                }}
                            >
                                English
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Sinhala");
                                    changeLanguage('si')
                                }}
                            >
                                සිංහල
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Tamil");
                                    changeLanguage('ta')
                                }}
                            >
                                தமிழ்
                            </button>
                        </MenuItem>
                    </div>
                </MenuItems>
            </Menu>

            <div className="flex justify-center gap-[15px] md:gap-[30px] items-center pt-[100px] md:pt-[130px] lg:pt-[150px] xl:pt-[30px] w-full">
                <div onClick={() => setIsOverViewSelected(true)} className={`${isOverViewSelected ? 'bg-[#FDC50C]' : 'bg-[#D9D9D9]'} rounded-2xl xl:ml-[80px] ${i18n.language === "si" ? "w-[150px] md:w-[250px]" : "w-[160px] md:w-[200px]"}  flex justify-center`}>
                    <p className={`${i18n.language === "en" ? "text-[20px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px]" : "text-[15px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px]"} font-bold px-[5px] py-[5px] md:px-[13px] md:py-[8px]`}>{t('t104')}</p>
                </div>
                <div onClick={() => setIsOverViewSelected(false)} className={`${!isOverViewSelected ? 'bg-[#FDC50C]' : 'bg-[#D9D9D9]'} rounded-2xl xl:ml-[80px] ${i18n.language === "si" ? "w-[150px] md:w-[250px]" : "w-[160px] md:w-[200px]"}  flex justify-center`}>
                    <p className={`${i18n.language === "en" ? "text-[20px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px]" : "text-[15px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px]"} font-bold px-[5px] py-[5px] md:px-[13px] md:py-[8px]`}>{t('t181')}</p>
                </div>
            </div>

            {
                isOverViewSelected ? <div>
                    <div className="grid grid-cols-2 mt-[30px] ml-[20px] mr-[20px] md:ml-[60px] md:mr-[60px] lg:ml-[80px] lg:mr-[80px] xl:ml-[150px] xl:mr-[150px] 2xl:ml-[240px] 2xl:mr-[240px]">
                        <div className="flex flex-col justify-center items-center mr-[10px] lg:mr-[20px] xl:mr-[30px]">
                            <div className="bg-[#D1B9F2] w-full flex justify-center rounded-t-xl h-[60px] items-center">
                                <p className="text-[#705597] text-[15px] md:text-[16px] lg:text-[18px] font-bold px-[20px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px]">{t('t182')}</p>
                            </div>
                            <div className="bg-[#EADCFE] w-full flex justify-center rounded-b-xl">
                                {
                                    loadingTreatmentStudent ?
                                        <div className="items-center justify-center flex p-3">
                                            <div className='w-7 h-7 border-2 border-t-transparent border-[#705597] rounded-full animate-spin'></div>
                                        </div>
                                        :
                                        <p className="text-[#705597] font-bold text-[40px] px-[20px] py-[10px]">{treatmentStudent}</p>
                                }

                            </div>
                        </div>
                        <div className="flex flex-col justify-center items-center ml-[10px] lg:ml-[20px] xl:ml-[30px]">
                            <div className="bg-[#CDE99A] w-full flex justify-center rounded-t-xl h-[60px] items-center">
                                <p className="text-[#698633] text-[15px] md:text-[16px] lg:text-[18px] font-bold px-[20px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px]">{t('t183')}</p>
                            </div>
                            <div className="bg-[#EFFADB] w-full flex justify-center rounded-b-xl">
                                {
                                    loadingControlStudent ?
                                        <div className="items-center justify-center flex p-3">
                                            <div className='w-7 h-7 border-2 border-t-transparent border-[#698633] rounded-full animate-spin'></div>
                                        </div>
                                        :
                                        <p className="text-[#698633] font-bold text-[40px] px-[20px] py-[10px]">{controlStudent}</p>
                                }
                            </div>
                        </div>
                        <div className="mt-[10px] flex flex-col justify-center items-center mr-[10px] lg:mr-[20px] xl:mr-[30px]">
                            <div className="bg-[#DDC69D] w-full flex justify-center rounded-t-xl h-[60px] items-center">
                                <p className="text-[#695531] text-[15px] md:text-[16px] lg:text-[18px] font-bold px-[20px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px]">{t('t184')}</p>
                            </div>
                            <div className="bg-[#FEF2DC] w-full flex justify-center rounded-b-xl">
                                {
                                    loadingTeacher ?
                                        <div className="items-center justify-center flex p-3">
                                            <div className='w-7 h-7 border-2 border-t-transparent border-[#695531] rounded-full animate-spin'></div>
                                        </div>
                                        :
                                        <p className="text-[#695531] font-bold text-[40px] px-[20px] py-[10px]">{teacherNumber}</p>
                                }
                            </div>
                        </div>
                        <div className="mt-[10px] flex flex-col justify-center items-center ml-[10px] lg:ml-[20px] xl:ml-[30px]">
                            <div className="bg-[#A1E0BB] w-full flex justify-center rounded-t-xl h-[60px] items-center">
                                <p className="text-[#336C4B] text-[15px] md:text-[16px] lg:text-[18px] font-bold px-[20px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px]">{t('t185')}</p>
                            </div>
                            <div className="bg-[#DBFAE8] w-full flex justify-center rounded-b-xl">
                                {
                                    loadingTranslator ?
                                        <div className="items-center justify-center flex p-3">
                                            <div className='w-7 h-7 border-2 border-t-transparent border-[#336C4B] rounded-full animate-spin'></div>
                                        </div>
                                        :
                                        <p className="text-[#336C4B] font-bold text-[40px] px-[20px] py-[10px]">{translatorNumber}</p>
                                }
                            </div>
                        </div>
                        <div className="mt-[10px] flex flex-col justify-center items-center mr-[10px] lg:mr-[20px] xl:mr-[30px]">
                            <div className="bg-[#A0BEE8] w-full flex justify-center rounded-t-xl h-[60px] items-center">
                                <p className="text-[#2B4B79] text-[15px] md:text-[16px] lg:text-[18px] font-bold px-[20px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px]">{t('t186')}</p>
                            </div>
                            <div className="bg-[#DBE8FA] w-full flex justify-center rounded-b-xl">
                                {
                                    loadingStudent ?
                                        <div className="items-center justify-center flex p-3">
                                            <div className='w-7 h-7 border-2 border-t-transparent border-[#2B4B79] rounded-full animate-spin'></div>
                                        </div>
                                        :
                                        <p className="text-[#2B4B79] font-bold text-[40px] px-[20px] py-[10px]">{studentsNumber}</p>
                                }
                            </div>
                        </div>
                        <div className="mt-[10px] flex flex-col justify-center items-center ml-[10px] lg:ml-[20px] xl:ml-[30px]">
                            <div className="bg-[#E2C565] w-full flex justify-center rounded-t-xl h-[60px] items-center">
                                <p className="text-[#7A5E00] text-[15px] md:text-[16px] lg:text-[18px] font-bold px-[20px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px]">{t('t187')}</p>
                            </div>

                            <div className="bg-[#FFEBA9] w-full flex justify-center rounded-b-xl">
                                {
                                    loadingTodayMails ?
                                        <div className="items-center justify-center flex p-3">
                                            <div className='w-7 h-7 border-2 border-t-transparent border-[#7A5E00] rounded-full animate-spin'></div>
                                        </div>
                                        :
                                        <p className="text-[#7A5E00] font-bold text-[40px] px-[20px] py-[10px]">{totalMessages}</p>
                                }
                            </div>
                        </div>
                    </div>
                </div> :
                    <div>
                        <div className="grid grid-cols-2 mt-[30px] ml-[20px] mr-[20px] md:ml-[60px] md:mr-[60px] lg:ml-[80px] lg:mr-[80px] xl:ml-[150px] xl:mr-[150px] 2xl:ml-[240px] 2xl:mr-[240px]">
                            <div className="flex flex-col justify-center items-center mr-[10px] lg:mr-[20px] xl:mr-[30px]">
                                <div className="bg-[#D1B9F2] w-full flex justify-center rounded-t-xl h-[60px] items-center">
                                    <p className="text-center text-[#705597] text-[15px] md:text-[16px] lg:text-[18px] font-bold px-[5px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px]">{t('t188')}</p>
                                </div>
                                <div className="bg-[#EADCFE] w-full flex justify-center rounded-b-xl">
                                    {
                                        loadingValues ?
                                            <div className="items-center justify-center flex p-3">
                                                <div className='w-7 h-7 border-2 border-t-transparent border-[#705597] rounded-full animate-spin'></div>
                                            </div>
                                            :
                                            <p className="text-[#705597] font-bold text-[40px] px-[20px] py-[10px]">{translatedEmails}</p>
                                    }
                                </div>
                            </div>
                            <div className="flex flex-col justify-center items-center ml-[10px] lg:ml-[20px] xl:ml-[30px] cursor-pointer" onClick={() => navigate('/researcher/rejected-letters')}>
                                <div className="bg-[#CDE99A] w-full flex justify-center rounded-t-xl h-[60px] items-center hover:bg-[#b8d980] transition-colors">
                                    <p className="text-center text-[#698633] text-[15px] md:text-[16px] lg:text-[18px] font-bold px-[20px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px]">{t('t189')}</p>
                                </div>
                                <div className="bg-[#EFFADB] w-full flex justify-center rounded-b-xl hover:bg-[#ddf5b8] transition-colors">
                                    {
                                        loadingValues ?
                                            <div className="items-center justify-center flex p-3">
                                                <div className='w-7 h-7 border-2 border-t-transparent border-[#698633] rounded-full animate-spin'></div>
                                            </div>
                                            :
                                            <p className="text-[#698633] font-bold text-[40px] px-[20px] py-[10px]">{rejectedMails}</p>
                                    }
                                </div>
                            </div>
                            <div className="mt-[10px] flex flex-col justify-center items-center mr-[10px] lg:mr-[20px] xl:mr-[30px] cursor-pointer" onClick={() => navigate('/researcher/pending-letters')}>
                                <div className="bg-[#A1E0BB] w-full flex justify-center rounded-t-xl h-[60px] items-center hover:bg-[#8fd4ab] transition-colors">
                                    <p className="text-center text-[#336C4B] text-[15px] md:text-[16px] lg:text-[18px] font-bold px-[20px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px]">{t('t190')}</p>
                                </div>
                                <div className="bg-[#DBFAE8] w-full flex justify-center rounded-b-xl hover:bg-[#cbf7dd] transition-colors">
                                    {
                                        loadingValues ?
                                            <div className="items-center justify-center flex p-3">
                                                <div className='w-7 h-7 border-2 border-t-transparent border-[#336C4B] rounded-full animate-spin'></div>
                                            </div>
                                            :
                                            <p className="text-[#336C4B] font-bold text-[40px] px-[20px] py-[10px]">{pendingEmails}</p>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
            }
            <div className="xl:hidden flex flex-col mt-[20px] md:mt-[30px] ml-[20px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[200px] lg:mr-[200px]" onClick={() => navigate('/researcher/managedata')}>
                <div className="flex items-center">
                    <div className="md:hidden bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg">
                        <MdStorage size={20} color="#FDC50C" />
                    </div>
                    <div className="hidden md:block bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg">
                        <MdStorage size={23} color="#FDC50C" />
                    </div>
                    <div className="bg-[#FFEBA9] py-[7px] md:py-[13px] pl-[10px] w-full rounded-r-lg">
                        <p className="text-black text-[15px] md:text-[18px]">{t('t191')}</p>
                    </div>
                </div>
            </div>
            <div className="xl:hidden flex flex-col mt-[15px] md:mt-[20px] ml-[20px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[200px] lg:mr-[200px]" onClick={() => navigate('/sendinvitation')} >
                <div className="flex items-center">
                    <div className="md:hidden bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg">
                        <MdMailOutline size={20} color="#FDC50C" />
                    </div>
                    <div className="hidden md:block bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg">
                        <MdMailOutline size={23} color="#FDC50C" />
                    </div>
                    <div className="bg-[#FFEBA9] py-[7px] md:py-[13px] pl-[10px] w-full rounded-r-lg">
                        <p className="text-black text-[15px] md:text-[18px]">{t('t192')}</p>
                    </div>
                </div>
            </div>
            <div className="xl:hidden flex flex-col mt-[15px] md:mt-[20px] ml-[20px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[200px] lg:mr-[200px]" onClick={() => navigate('/researcher/penpalmatching')}>
                <div className="flex items-center">
                    <div className="md:hidden bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg">
                        <MdPeople size={20} color="#FDC50C" />
                    </div>
                    <div className="hidden md:block bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg">
                        <MdPeople size={23} color="#FDC50C" />
                    </div>
                    <div className="bg-[#FFEBA9] py-[7px] md:py-[13px] pl-[10px] w-full rounded-r-lg">
                        <p className="text-black text-[15px] md:text-[18px]">{t('t193')}</p>
                    </div>
                </div>
            </div>

            <div className="xl:hidden flex flex-col mt-[15px] md:mt-[20px] ml-[20px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[200px] lg:mr-[200px]" onClick={() => navigate('/researcher/resetpassword')}>
                <div className="flex items-center">
                    <div className="md:hidden bg-[#A07B00] p-[6px] md:p-[15px] rounded-l-lg">
                        <MdLockReset size={25} color="#FDC50C" />
                    </div>
                    <div className="hidden md:block bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg">
                        <MdLockReset size={23} color="#FDC50C" />
                    </div>
                    <div className="bg-[#FFEBA9] py-[7px] md:py-[13px] pl-[10px] w-full rounded-r-lg">
                        <p className="text-black text-[15px] md:text-[18px]">{t('t194')}</p>
                    </div>
                </div>
            </div>

            <div className="xl:hidden flex flex-col mt-[15px] md:mt-[20px] ml-[20px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[200px] lg:mr-[200px]" onClick={() => navigate('/researcher/data/download')}>
                <div className="flex items-center">
                    <div className="md:hidden bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg">
                        <MdDownload size={20} color="#FDC50C" />
                    </div>
                    <div className="hidden md:block bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg">
                        <MdDownload size={23} color="#FDC50C" />
                    </div>
                    <div className="bg-[#FFEBA9] py-[7px] md:py-[13px] pl-[10px] w-full rounded-r-lg">
                        <p className="text-black text-[15px] md:text-[18px]">{t('t195_2')}</p>
                    </div>
                </div>
            </div>

            <div className="xl:hidden flex flex-col mt-[15px] md:mt-[20px] ml-[20px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[200px] lg:mr-[200px]" onClick={() => navigate('/researcher/accounts/select')}>
                <div className="flex items-center">
                    <div className={`md:hidden bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg items-center justify-center flex ${i18n.language === "ta" && " h-[50px]"}`}>
                        <MdInfo size={20} color="#FDC50C" />
                    </div>
                    <div className="hidden md:block bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg">
                        <MdInfo size={23} color="#FDC50C" />
                    </div>
                    <div className={`md:hidden bg-[#FFEBA9] py-[7px] md:py-[13px] pl-[10px] w-full rounded-r-lg flex ${i18n.language === "ta" && "items-center justify-center h-[50px]"}`}>
                        <p className="text-black text-[15px] md:text-[18px]">{logDetails?.email === "admin@gmail.com" ? t('t424') : t('t421')}</p>
                    </div>
                    <div className={`hidden md:block bg-[#FFEBA9] py-[7px] md:py-[13px] pl-[10px] w-full rounded-r-lg`}>
                        <p className="text-black text-[15px] md:text-[18px]">{logDetails?.email === "admin@gmail.com" ? t('t424') : t('t421')}</p>
                    </div>
                </div>
            </div>

            <div className="xl:hidden flex flex-col mt-[15px] md:mt-[20px] ml-[20px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[200px] lg:mr-[200px] cursor-pointer" onClick={() => navigate('/researcher/school-letter-report')}>
                <div className="flex items-center">
                    <div className="md:hidden bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg">
                        <MdSchool size={20} color="#FDC50C" />
                    </div>
                    <div className="hidden md:block bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg">
                        <MdSchool size={23} color="#FDC50C" />
                    </div>
                    <div className="bg-[#FFEBA9] py-[7px] md:py-[13px] pl-[10px] w-full rounded-r-lg">
                        <p className="text-black text-[15px] md:text-[18px]">School Letter Report</p>
                    </div>
                </div>
            </div>

            <div className="xl:hidden mx-[20px] md:mx-[150px] lg:mx-[200px] mt-[15px] md:mt-[20px] pb-[120px]">
                <div className="bg-gradient-to-br from-[#FFF6DA] to-[#FFEBA9] border border-[#E2C565] rounded-2xl px-[18px] py-[16px] shadow-sm">
                    <p className="text-[14px] md:text-[17px] font-bold text-[#7A5E00] mb-[12px]">Download Letters by Round</p>
                    <select
                        id="mobile-round-select"
                        value={selectedRound}
                        onChange={(e) => setSelectedRound(e.target.value)}
                        className="w-full border border-[#E2C565] bg-white text-gray-700 text-[13px] md:text-[14px] rounded-lg py-[8px] px-[12px] focus:outline-none focus:ring-2 focus:ring-[#A07B00] cursor-pointer mb-[10px]"
                    >
                        {ROUND_BOUNDARIES.map((r) => (
                            <option key={r.value} value={r.value}>{r.label}</option>
                        ))}
                    </select>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-[10px]">
                        <button
                            id="mobile-round-excel-btn"
                            disabled={roundDownloadLoading}
                            onClick={downloadRoundExcel}
                            className="flex items-center justify-center gap-[6px] bg-[#217346] text-white rounded-lg text-[13px] md:text-[14px] py-[10px] px-[12px] hover:bg-opacity-90 disabled:opacity-50 font-semibold shadow-sm"
                        >
                            <MdDownload size={17} />
                            {roundDownloadLoading ? "Downloading..." : "Download Excel"}
                        </button>
                        <button
                            id="mobile-round-pdf-btn"
                            disabled={roundDownloadLoading}
                            onClick={downloadRoundPdf}
                            className="flex items-center justify-center gap-[6px] bg-[#A07B00] text-white rounded-lg text-[13px] md:text-[14px] py-[10px] px-[12px] hover:bg-opacity-90 disabled:opacity-50 font-semibold shadow-sm"
                        >
                            <MdDownload size={17} />
                            {roundDownloadLoading ? "Downloading..." : "Download PDF"}
                        </button>
                    </div>
                </div>
            </div>

            <div className="xl:hidden grid grid-cols-4 fixed bottom-0 w-full border-t border-gray-300 bg-white z-30">
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/home-y.svg" alt="home" onClick={() => navigate('/mobile/researcher/dashboard')} /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/person.svg" alt="person" onClick={() => navigate('/mobile/researcher/profile')} /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/mail.svg" alt="mail" onClick={() => navigate('/mobile/researcher/mailbox/inbox')} /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/settings.svg" alt="settings" onClick={() => navigate('/mobile/researcher/settings')} /></div>
            </div>
        </div>
    )
}

export default ResearcherDashboardMobilePage;
